// extracted by mini-css-extract-plugin
module.exports = {"image":"idt-svginputoptiongrid_image__jyijb"};